<template>
	<div>
		<transition
			name="fade"
			enter-active-class="animated fadeIn"
			leave-active-class="animated fadeOut"
		>
			<b-container>
				<h3 class="text-center  mb-5 ">
					{{ $t("setLevel.setLevel") }}
				</h3>
				<b-form>
					<section>
						<!-- ================================= supplier_id $ lastName ============================== -->
						<b-row align-h="between">
							<!--------------------------------- supplier_id -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="supplier_id_group"
									:label="$t('setLevel.supplierId')"
									label-cols-sm="5"
									label-for="supplier_id"
								>
									<b-form-input
										id="supplier_id"
										type="text"
										v-model="form.supplier_id"
										aria-describedby="supplier_id-live-feedback"
									></b-form-input>
									<b-form-invalid-feedback id="supplier_id-live-feedback">
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<b-col md="6"> </b-col>
						</b-row>
						<!-- ================================= net_amount $ downpayment_amount ============================== -->
						<b-row align-h="between">
							<!--------------------------------- net_amount -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="cart_amount_group"
									:label="$t('setLevel.cartAmount')"
									label-for="net_amount"
									label-cols-sm="5"
								>
									<vue-numeric
										id="net_amount"
										v-model="$v.financial.net_amount.$model"
										aria-describedby="net_amount-live-feedback"
										currency="﷼"
										currency-symbol-position="suffix"
										class="form-control"
										:class="{
											'is-invalid': $v.financial.net_amount.$error,
										}"
										@blur="$v.financial.net_amount.$touch()"
									></vue-numeric>
									<b-form-invalid-feedback
										id="net_amount-live-feedback"
										v-show="!$v.financial.net_amount.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="net_amount-live-feedback"
										v-show="!$v.financial.net_amount.between"
									>
										{{ $t("validation.amountInvalid") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>

							<!--------------------------------- downpayment_amount -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="downpayment_amount_group"
									:label="$t('setLevel.downpaymentAamount')"
									label-for="downpayment_amount"
									label-cols-sm="5"
								>
									<vue-numeric
										id="downpayment_amount"
										v-model.trim="$v.downpayment_amount.$model"
										:state="$v.downpayment_amount.$error"
										aria-describedby="downpayment_amount-live-feedback"
										currency="﷼"
										currency-symbol-position="suffix"
										class="form-control"
										:class="{ 'is-invalid': $v.downpayment_amount.$error }"
										@blur="$v.downpayment_amount.$touch()"
									></vue-numeric>
									<!-- <div v-if="financial.downpayment_rate">{{ financial.downpayment_rate }}</div> -->
									<b-form-invalid-feedback
										id="downpayment_amount-live-feedback"
										v-show="!$v.downpayment_amount.required"
									>
										{{ $t("validation.required") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="downpayment_amount-live-feedback"
										v-show="!$v.downpayment_amount.max"
									>
										{{ $t("validation.downPaymentInvalid") }}
									</b-form-invalid-feedback>
									<b-form-invalid-feedback
										id="downpayment_amount-live-feedback"
										v-show="!$v.downpayment_amount.min"
									>
										مقدار پیش پرداخت باید حداقل
										<span>
											<vue-numeric
												separator=","
												v-model="downpaymentMin"
												read-only
											>
											</vue-numeric> </span
										>ریال باشد
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
						</b-row>

						<!-- ================================= number_of_instalment ============================== -->
						<b-row align-h="between">
							<!--------------------------------- number_of_instalment -----------------------------------------  -->
							<b-col md="6">
								<b-form-group
									id="number_of_inastalment_group"
									:label="$t('setLevel.numberOfInastalment')"
									label-cols-sm="5"
									label-for="number_of_instalment"
									:state="validateStateFinancial('number_of_instalment')"
								>
									<b-form-select
										v-model="$v.financial.number_of_instalment.$model"
										:options="number_of_inastalment_options"
										:state="validateStateFinancial('number_of_instalment')"
										aria-describedby="number_of_instalment-live-feedback"
										class="form-control"
									></b-form-select>
									<b-form-invalid-feedback
										id="number_of_instalment-live-feedback"
									>
										{{ $t("validation.requiredToFill") }}
									</b-form-invalid-feedback>
								</b-form-group>
							</b-col>
							<b-col md="6"> </b-col>
						</b-row>

						<!-- button -->
						<b-row align-h="center">
							<b-button
								type="button"
								size="sm"
								variant="info"
								class="btn  btn-size--md btn-hover--3d mt-1 mb-3"
								center
								@click.prevent="clac"
								>{{ $t("setLevel.calc") }}</b-button
							>
						</b-row>
						<!-- ====================++++ show sec ++++====================== -->
						<section>
							<transition
								name="fade"
								enter-active-class="animated fadeIn"
								leave-active-class="animated fadeOut"
							>
								<div v-if="show">
									<!-- ========================== level =========================-->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.level')"
												label-for="level"
												label-cols-sm="7"
											>
												<b-input
													id="=level"
													plaintext
													v-model="get.level_str"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>
										<b-col md="6"></b-col>
									</b-row>

									<!-- ========================== downpayment & total instalments =========================-->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.downpayment')"
												label-for="downpayment"
												label-cols-sm="7"
											>
												<b-input
													id="=downpayment"
													plaintext
													v-model="get.downpayment"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>

										<!-- ---------------- total_amount_of_instalments ---------------- -->
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.totalInstalments')"
												label-for="total_amount_of_instalments"
												label-cols-sm="7"
											>
												<b-input
													id="=total_amount_of_instalments"
													plaintext
													v-model="get.total_amount_of_instalments"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>
									</b-row>

									<!-- ========================== instalment_amount & total_amount =========================-->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.instalmentAmount')"
												label-for="instalment_amount"
												label-cols-sm="7"
											>
												<b-input
													id="=instalment_amount"
													plaintext
													v-model="get.instalment_amount"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>

										<!-- ---------------- total_amount ---------------- -->
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.total_amount')"
												label-for="total_amount"
												label-cols-sm="7"
											>
												<b-input
													id="=total_amount"
													plaintext
													v-model="get.total_amount"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>
									</b-row>

									<!-- ========================== suretys & total_amount =========================-->
									<b-row align-h="between">
										<b-col md="6">
											<b-form-group
												:label="$t('setLevel.suerties')"
												label-for="suretys"
												label-cols-sm="7"
											>
												<b-input
													id="=suretys"
													plaintext
													v-model="get.suretys"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>

										<!-- ---------------- total_amount ---------------- -->
										<b-col md="6">
											<b-form-group
												v-show="false"
												:label="$t('setLevel.total_amount')"
												label-for="total_amount"
												label-cols-sm="7"
											>
												<b-input
													id="=total_amount"
													plaintext
													v-model="get.total_amount"
													readonly
												>
												</b-input>
											</b-form-group>
										</b-col>
									</b-row>
									<hr />
									<br />
								</div>
							</transition>
						</section>

						<!-- ====================++++ check sec ++++====================== -->
						<section>
							<!-- ================================= has_check ============================== -->
							<b-row align-h="between" class="mb-5">
								<b-col md="6">
									<b-form-radio-group
										id="has_check"
										v-model="$v.form.checkinfo.has_check.$model"
										:options="has_check_options"
										:aria-describedby="has_check"
										name="has_check"
									></b-form-radio-group>
								</b-col>
								<b-col md="6"></b-col>
							</b-row>

							<!-- ================================= sayyad_number $ city ============================== -->
							<b-row align-h="between">
								<!--------------------------------- sayyad_number -----------------------------------------  -->
								<b-col md="6">
									<b-form-group
										id="sayyad_number_group"
										:label="$t('setLevel.checkinfo.sayyad_number')"
										label-cols-sm="5"
										label-for="sayyad_number"
									>
										<b-form-input
											id="sayyad_number"
											type="text"
											v-model="$v.form.checkinfo.sayyad_number.$model"
											:state="validateStateCheck('sayyad_number')"
											aria-describedby="sayyad_number-live-feedback"
										></b-form-input>
										<b-form-invalid-feedback
											id="sayyad_number-live-feedback"
											v-show="
												!$v.form.checkinfo.sayyad_number.required &
													$v.form.checkinfo.sayyad_number.$dirty
											"
										>
											{{ $t("validation.required") }}
										</b-form-invalid-feedback>
										<b-form-invalid-feedback
											id="sayyad_number-live-feedback"
											v-show="
												!$v.form.checkinfo.sayyad_number.minLength &
													$v.form.checkinfo.sayyad_number.maxLength
											"
										>
											{{ $t("validation.amountInvalid") }}
										</b-form-invalid-feedback>
										<small
											class="textRed"
											id="sayyad_number-live-feedback"
											v-show="!has_check"
										>
											{{ $t("setLevel.checkinfo.suertyRequired") }}
										</small>
									</b-form-group>
								</b-col>
								<!--------------------------------- city -----------------------------------------  -->
								<b-col md="6">
									<b-form-group
										id="city_group"
										:label="$t('setLevel.checkinfo.city')"
										label-for="city"
										label-cols-sm="5"
									>
										<b-form-input
											id="city"
											v-model="$v.form.checkinfo.city.$model"
											:state="validateStateCheck('city')"
											aria-describedby="city-live-feedback"
										></b-form-input>
										<b-form-invalid-feedback
											id="city-live-feedback"
											v-show="
												!$v.form.checkinfo.city.required &
													$v.form.checkinfo.sayyad_number.$dirty
											"
										>
											{{ $t("validation.required") }}
										</b-form-invalid-feedback>
										<small
											class="textRed"
											id="sayyad_number-live-feedback"
											v-show="!has_check"
										>
											{{ $t("setLevel.checkinfo.suertyRequired") }}
										</small>
									</b-form-group>
								</b-col>
							</b-row>
							<!-- ================================= branch_name $ branch_code ============================== -->
							<b-row align-h="between">
								<!--------------------------------- branch_name -----------------------------------------  -->
								<b-col md="6">
									<b-form-group
										id="branch_name_group"
										:label="$t('setLevel.checkinfo.branchName')"
										label-cols-sm="5"
										label-for="branch_name"
									>
										<b-form-input
											id="branch_name"
											type="text"
											v-model="$v.form.checkinfo.branch_name.$model"
											:state="validateStateCheck('branch_name')"
											aria-describedby="branch_name-live-feedback"
										></b-form-input>
										<b-form-invalid-feedback
											id="sayyad_number-branch_name-feedback"
											v-show="
												!$v.form.checkinfo.branch_name.required &
													$v.form.checkinfo.branch_name.$dirty
											"
										>
											{{ $t("validation.required") }}
										</b-form-invalid-feedback>
										<b-form-invalid-feedback
											id="sayyad_number-live-feedback"
											v-show="
												!$v.form.checkinfo.branch_name.minLength &
													$v.form.checkinfo.branch_name.maxLength
											"
										>
											{{ $t("validation.amountInvalid") }}
										</b-form-invalid-feedback>
										<small
											class="textRed"
											id="sayyad_number-live-feedback"
											v-show="!has_check"
										>
											{{ $t("setLevel.checkinfo.suertyRequired") }}
										</small>
									</b-form-group>
								</b-col>
								<!--------------------------------- branch_code -----------------------------------------  -->
								<b-col md="6">
									<b-form-group
										id="branch_code_group"
										:label="$t('setLevel.checkinfo.branch_code')"
										label-for="branch_code"
										label-cols-sm="5"
									>
										<b-form-input
											id="city"
											v-model="$v.form.checkinfo.branch_code.$model"
											:state="validateStateCheck('branch_code')"
											aria-describedby="branch_code-live-feedback"
										></b-form-input>
										<b-form-invalid-feedback
											id="branch_code-live-feedback"
											v-show="
												!$v.form.checkinfo.branch_code.required &
													$v.form.checkinfo.branch_code.$dirty
											"
										>
											{{ $t("validation.required") }}
										</b-form-invalid-feedback>
										<small
											class="textRed"
											id="sayyad_number-live-feedback"
											v-show="!has_check"
										>
											{{ $t("setLevel.checkinfo.suertyRequired") }}
										</small>
									</b-form-group>
								</b-col>
							</b-row>
						</section>
					</section>

					<!-- button -->
					<b-row align-h="center"  v-show="!edit">
						<b-button
							type="button"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							@click.prevent="submit"
							>{{ $t("register.save") }}</b-button
						>
					</b-row>
					<b-row align-h="center" v-show="edit">
						<b-button
							type="button"
							size="lg"
							class="btn btn-bg--primary  btn-size--md btn-hover--3d mt-5 mb-3"
							center
							@click.prevent="updateCustomer"
							>{{ $t("register.edit") }}</b-button
						>
					</b-row>
				</b-form>
			</b-container>
		</transition>
	</div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";



import { validationMixin } from "vuelidate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
	required,
	between,
	minLength,
	maxLength,
} from "vuelidate/lib/validators";

import VueNumeric from "vue-numeric";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	mixins: [validationMixin],
	data() {
		return {
			isRegisterCompleted:false,
			edit:false,
			financial: {
				net_amount: 100000000,
				number_of_instalment: "",
				downpayment_rate: "",
			},
			form: {
				supplier_id: "",
				level: "",
				financial: {
					cart_amount: "",
					number_of_instalment: "",
					downpayment_rate: "",
				},
				checkinfo: {
					has_check: 1,
					sayyad_number: "",
					city: "",
					branch_name: "",
					branch_code: "",
				},
			},
			get: {
				downpayment: "",
				level_str: "",
				total_amount: "",
				instalment_amount: "",
				total_amount_of_instalments: "",
				suretys: "",
			},

			downpayment_amount:"",
			show: false,
			number_of_inastalment_options: [
				{ value: 12, text: "12" },
				{ value: 24, text: "24" },
			],
			has_check_options: [
				{ value: 1, text: this.$t("setLevel.hasCheck") },
				{ value: 0, text: this.$t("setLevel.hasNotCheck") },
			],
		};
	},
	validations: {
		financial: {
			net_amount: { required, between: between(10000000, 1000000000) },
			number_of_instalment: {
				required,
			},
		},
		form: {
			// supplier_id: { required },

			checkinfo: {
				has_check: { required },
				sayyad_number: {
					required,
					minLength: minLength(16),
					maxLength: maxLength(16),
				},
				city: { required },
				branch_name: { required },
				branch_code: { required },
			},
		},
		downpayment_amount: {
			required,
			max(value) {
				if (value > this.downpaymentMax) {
					return false;
				} else {
					return true;
				}
			},
			min(value) {
				if (value < this.downpaymentMin) {
					return false;
				} else {
					return true;
				}
			},
		},
	},
	computed: {
		downpaymentMax() {
			return this.financial.net_amount;
		},
		downpaymentMin: {
			get()
			{
				return this.financial.net_amount * 0.25;
			},
			set(newValue)
			{
				return newValue
			}
			
		},
		has_check() {
			if(this.form.checkinfo)
			{
				return this.form.checkinfo.has_check;
			}
			return null
			
		},
		net_amount_financ() {
			return this.form.financial.net_amount / 1000000;
		},
	},
	watch: {
		downpayment_amount() {
			this.financial.downpayment_rate =
				this.downpayment_amount / this.financial.net_amount;
		},
	},
	mounted() {
		
		if(this.$route.name=="setTheLevel")
		{
			
			this.isRegisterCompleted = true
		}
		if(this.$route.name=="supplierSetLevel")
		{
			this.isRegisterCompleted = true
		}
		
		this.getCustomer();
	},
	methods: {
		clac() {
			this.$v.financial.$touch();
			if (this.$v.financial.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				console.log("financ: ", this.financial);
				this.$store
					.dispatch("customerClac", this.financial)
					.then((response) => {
						console.log(response);
						load.hide();
						this.get = response.body;
						this.form.level = response.body.level;
						this.form.financial.net_amount =
							this.financial.net_amount / 1000000;
						this.form.financial.number_of_instalment = this.financial.number_of_instalment;
						this.form.financial.downpayment_rate = this.financial.downpayment_rate;
						this.show = true;
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},
		submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				if (!this.show) {
					this.$noty.error(this.$t("alert.shoulCalc"));
				} else {
					let load = this.$loading.show();
					let form = {
					supplier_id: this.form.supplier_id,
					level: this.form.level,
					financial: {
						cart_amount: parseInt(this.financial.net_amount/1000000),
						number_of_instalment: this.form.financial.number_of_instalment,
						downpayment: parseInt(this.downpayment_amount/1000000),
					},
					checkinfo: {
						has_check: this.form.checkinfo.has_check,
						sayyad_number: this.form.checkinfo.sayyad_number,
						city: this.form.checkinfo.city,
						branch_name: this.form.checkinfo.branch_name,
						branch_code: this.form.checkinfo.branch_code,
					},
				};
					this.$store
						.dispatch("updateCustomer", form)
						.then((response) => {
							console.log(response);
							load.hide();
							this.$store;
							console.log("isRegister: " + this.isRegisterCompleted + "---------------------------")
							if(!this.isRegisterCompleted)
							{
								this.$router.push({ name: "registerPage" });
							}
							else
							{
								this.$noty.success(this.$t("alert.successUpdated"))
							}
							
						})
						.catch((err) => {
							console.log(err);
							this.$noty.error(err.body.error);
							load.hide();
						});
				}
			}
		},
		setFormNull()
		{
			if(!this.form.financial)
			{
				this.form.financial={
					net_amount: "",
					number_of_instalment: "",
					downpayment_rate: "",
				}
					
			}
			if(!this.form.checkinfo)
			{
				this.form.checkinfo= {
					has_check: 1,
					sayyad_number: "",
					city: "",
					branch_name: "",
					branch_code: "",
				}
			}
		},
		getCustomer() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getCustomer")
				.then((response) => {
					console.log(response);
					load.hide();
					this.form = response.body;
					this.setFormNull()
					console.log(this.form + JSON.stringify(this.form))
					this.edit = true;
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.error);
					load.hide();
					this.edit = false;
				});
		},
		updateCustomer() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);

				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				let form = {
					supplier_id: this.form.supplier_id,
					level: this.form.level,
					financial: {
						cart_amount: parseInt(this.financial.net_amount/1000000),
						number_of_instalment: this.form.financial.number_of_instalment,
						downpayment:parseInt(this.downpayment_amount/1000000),
					},
					checkinfo: {
						has_check: this.form.checkinfo.has_check,
						sayyad_number: this.form.checkinfo.sayyad_number,
						city: this.form.checkinfo.city,
						branch_name: this.form.checkinfo.branch_name,
						branch_code: this.form.checkinfo.branch_code,
					},
				};
				console.log("form: ", form);
				this.$store
					.dispatch("updateCustomer", form)
					.then((response) => {
						console.log(response);
						load.hide();
							if(!this.isRegisterCompleted)
							{
								this.$router.push({ name: "registerPage" });
							}
							else
							{
								this.$noty.success(this.$t("alert.successUpdated"))
							}
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},

		validateStateFinancial(name) {
			const { $dirty, $error } = this.$v.financial[name];
			return $dirty ? !$error : null;
		},
		validateStateCheck(name) {
			const { $dirty, $error } = this.$v.form.checkinfo[name];

			return $dirty ? !$error : null;
		},
		checkFeedback() {
			if (!this.has_check) {
				return "salam";
			}
		},
	},
	components: {
		datePicker: VuePersianDatetimePicker,
		VueNumeric,
	},
};
</script>

<style scoped>
.custom-select {
	border-radius: 0px;
}
.vpd-icon-btn {
	display: block;
	/* width: 0%; */
	cursor: pointer;
	background-color: rgb(230, 253, 254) !important;
	padding: 0px 0px 0px 0px !important;
	margin: 0px 0px 0px 0px !important;
	/* height: 0px 0px 0px 0px; */
}
element.style {
	background-color: rgb(230, 253, 254);
}

div.file-listing {
	background-color: rgba(216, 216, 216, 0.493) !important;
	border-radius: 3px;
}

span.remove-file {
	color: red;
	cursor: pointer;
	float: left;
}

input[type="file"] {
	opacity: 0;

	top: -1px;

	position: fixed;
	cursor: pointer;
}
.textBlue {
	color: rgb(93, 153, 187);
}
.textRed {
	color: red;
}

.fade-enter-to,
.fade-leave {
	transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css">

</style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
